import { render, staticRenderFns } from "./secret-i18n.vue?vue&type=template&id=357564ae&scoped=true&"
import script from "./secret-i18n.vue?vue&type=script&lang=js&"
export * from "./secret-i18n.vue?vue&type=script&lang=js&"
import style0 from "./secret-i18n.vue?vue&type=style&index=0&id=357564ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357564ae",
  null
  
)

export default component.exports